<template>
  <section class="expertise-section">
    <div class="expertise-overlay"></div>
    <div class="expertise-content section-container">
      <h2 class="section-title">{{ $t('home-page.area-expertise.title') }}</h2>
      <div class="expertise-grid">
        <div class="expertise-card" data-aos="fade-up">
          <img src="@/assets/vehicle.png" alt="Heavy Vehicle Operations">
          <p>{{ $t('home-page.area-expertise.expertise[0]') }}</p>
        </div>
        <div class="expertise-card" data-aos="fade-up" data-aos-delay="100">
          <img src="@/assets/education.png" alt="Training and Development">
          <p>{{ $t('home-page.area-expertise.expertise[1]') }}</p>
        </div>
        <div class="expertise-card" data-aos="fade-up" data-aos-delay="200">
          <img src="@/assets/warehouse.png" alt="Storage and Transportation">
          <p>{{ $t('home-page.area-expertise.expertise[2]') }}</p>
        </div>
      </div>
      <div class="cta-container">
        <router-link to="/expertise" class="btn-cta">{{ $t('home-page.area-expertise.see-more') }}</router-link>
      </div>
    </div>
  </section>
</template>

<style scoped>
.expertise-section {
  position: relative;
  background: url('@/assets/group-trucks-parked-line-truck-stop.webp') no-repeat center center;
  background-size: cover;
  color: white;
}
.expertise-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(10, 45, 97, 0.85);
}
.expertise-content {
  position: relative;
  z-index: 2;
}
.expertise-content .section-title {
  color: white;
}
.expertise-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  max-width: 1000px;
  margin: 4rem auto 0 auto;
}
.expertise-card {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
.expertise-card img {
  width: 60px;
  height: 60px;
  filter: invert(1); /* Make icons white */
}
.expertise-card p {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 500;
  line-height: 1.6;
}
.cta-container {
  text-align: center;
  margin-top: 4rem;
}
.btn-cta {
  background-color: #fcbc0d;
  color: #0A2D61;
  padding: 14px 32px;
  border-radius: 6px;
  text-decoration: none;
  font-weight: 700;
  text-transform: uppercase;
  transition: all 0.3s ease;
}
.btn-cta:hover {
  background-color: #fff;
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
}
</style>